var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGettingHomeReady = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 44,
    viewBox: "0 0 20 44",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "premiumIcon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.136,
    height: 3.976,
    x: 0.293,
    y: 1.883,
    rx: 1.988,
    transform: "rotate(164 7.361 3.871)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.309 42.012v.011a1.977 1.977 0 1 1-3.954-.01h-.342a1.38 1.38 0 0 1-1.38-1.405 1.38 1.38 0 0 1-.596-2.011 1.377 1.377 0 0 1-.242-1.731h-1.32l-1.02-4.153h-.379v-4.947H3.38v-2.5a1.988 1.988 0 0 1-1.004-3.846l13.163-3.774a1.988 1.988 0 0 1 1.096 3.821l-.908.26v6.039h.928v4.947h-.14l-1.257 4.153h-1.322a1.38 1.38 0 0 1-.425 1.874 1.38 1.38 0 0 1-.484 1.762 1.38 1.38 0 0 1-1.374 1.51h-.343zM7.355 27.766h3.887v-4.753l-3.887 1.115v3.638z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.326,
    height: 3.976,
    x: 0.35,
    y: 7.167,
    rx: 1.988,
    transform: "rotate(164 10.013 9.155)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18.222,
    height: 3.976,
    x: 0.382,
    y: 13.396,
    rx: 1.988,
    transform: "rotate(164 9.493 15.384)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGettingHomeReady);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/getting-home-ready.6f65c7227cab2592f4c545ac477bcdb6.svg";